import { proxy, subscribe } from 'valtio';
import { accountState } from './legacyStores/account';
import { appConfigState } from './legacyStores/appConfig';
import { dashboardState } from './legacyStores/dashboardClient';
import { genericState } from './legacyStores/generic';
import { appStore } from '@store/appStore';
import { teamState } from './legacyStores/teamData';
import { todoState } from './legacyStores/todos';
import { guidepostState } from './legacyStores/guidepost';
const STORAGE_KEY = 'appState';

interface RootState {
    accountState: typeof accountState;
    appConfigState: typeof appConfigState;
    dashboardState: typeof dashboardState;
    genericState: typeof genericState;
    loginStore: typeof appStore;
    teamState: typeof teamState;
    todoState: typeof todoState;
    guidepostState: typeof guidepostState;
}

const store = proxy<RootState>({
    accountState,
    appConfigState,
    dashboardState,
    genericState,
    loginStore: appStore,
    teamState,
    todoState,  
    guidepostState
});

// Load all stores from localStorage
function loadState() {
    const savedState = localStorage.getItem(STORAGE_KEY);
    if (savedState) {
      const parsedState = JSON.parse(savedState);
      Object.keys(parsedState).forEach((key) => {
        const typedKey = key as keyof RootState;
        if (store[typedKey] && typeof store[typedKey] === 'object') {
          Object.assign(store[typedKey], parsedState[typedKey]);
        }
      });
    }
  }

// Save all stores to localStorage
function saveState() {
    const serializableState: Record<string, any> = {};
    Object.keys(store).forEach((key) => {
      const typedKey = key as keyof RootState;
      // Exclude stores you don't want to persist, e.g., appConfigState
      const excludedStores = ['appConfigState', 'guidepostState'];
      if (!excludedStores.includes(typedKey)) {
        // Only persist stores that are not functions and are defined
        if (store[typedKey] !== undefined && typeof store[typedKey] !== 'function') {
          serializableState[typedKey] = store[typedKey];
        }
      }
    });
  
    localStorage.setItem(STORAGE_KEY, JSON.stringify(serializableState));
  }

// Subscribe to changes and automatically update localStorage
subscribe(store, saveState);

// Load state from localStorage on app load
loadState();

export default store;

  